import React from "react";
import { Container } from "react-bootstrap";


class ManualeDelleCiv extends React.Component {
  render() {
    return (
      <div className="ManualeDelleCiv">
        <header className="App-body">
          <Container>
            <iframe
              src={"https://aoe4guide.it/"}
              title="ManualeDelleCiv"
              width="100%"
              height="1000"
            ></iframe>
          </Container>
        </header>
      </div>
    );
  }
}

export default ManualeDelleCiv;
